// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"96":"c3719c51","219":"45aea55d","262":"6fd62bf4","392":"0692560c","401":"8199a68e","568":"f1fd89fb","591":"9d0ab09b","610":"38334c23","621":"62df5767","622":"525b88d5","697":"2cc90a4c","737":"af4d2152","739":"12f096d4","844":"dc4110aa"}[chunkId] + ".js";
};